import React, { useState, useEffect } from "react";
import { document } from "global";
import { useProfileRanks, useProfileOverallRanking } from "api/summonerProfileApi";

const BasicTextRankPage = (props) => {
  const { season, summonerName, region, queueType } = props;
  const [time, setTime] = useState(Date.now());

  useEffect(() => {
    const interval = setInterval(() => setTime(Date.now()), 30000);

    if (document) {
      document.body.style.backgroundColor = "white";
    }

    return () => {
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    refetch();
    refetchRanking();
  }, [time]);

  const { data, loading, refetch } = useProfileRanks(summonerName, region, { seasonId: season }, { fetchPolicy: "network-only" });

  const {
    data: rankingData,
    loading: loadingRanking,
    error: errorRanking,
    refetch: refetchRanking,
  } = useProfileOverallRanking(summonerName, region, queueType, {
    fetchPolicy: "network-only",
  });

  return !loading || loadingRanking ? getRankText(data, rankingData) : <div>Loading...</div>;
};

const getRankText = (data, rankingData) => {
  const ranks = data ? data.fetchProfileRanks.rankScores : null;
  const overallRank = rankingData && rankingData.overallRanking ? rankingData.overallRanking.overallRanking : null;
  if (!ranks || ranks.length == 0 || !overallRank) return <div className="basic-text-rank-page">No Ranks Found</div>;

  const currentRank = ranks[0];
  const rankText =
    currentRank.tier.toLowerCase() == "master" ||
    currentRank.tier.toLowerCase() == "grandmaster" ||
    currentRank.tier.toLowerCase() == "challenger"
      ? ""
      : currentRank.rank;

  const capitalizedTier = currentRank.tier.charAt(0).toUpperCase() + currentRank.tier.slice(1).toLowerCase();
  if (!data) return <div className="basic-text-rank-page">Loading...</div>;
  return (
    <div className="basic-text-rank-page">
      <div>
        {capitalizedTier} {rankText} {currentRank.lp} LP, Rank #{overallRank}
      </div>
    </div>
  );
};

export default BasicTextRankPage;
